export enum DayOfTheWeek {
  MONDAY = "MONDAY",
  TUESDAY = "TUESDAY",
  WEDNESDAY = "WEDNESDAY",
  THURSDAY = "THURSDAY",
  FRIDAY = "FRIDAY",
  SATURDAY = "SATURDAY",
  SUNDAY = "SUNDAY",
}

export const ALL_WEEKDAYS = [
  DayOfTheWeek.MONDAY,
  DayOfTheWeek.TUESDAY,
  DayOfTheWeek.WEDNESDAY,
  DayOfTheWeek.THURSDAY,
  DayOfTheWeek.FRIDAY,
];

export const ALL_WEEKEND_DAYS = [DayOfTheWeek.SATURDAY, DayOfTheWeek.SUNDAY];

export function isDayOfWeek(dayOfWeek: string): dayOfWeek is DayOfTheWeek {
  return (
    dayOfWeek === DayOfTheWeek.MONDAY ||
    dayOfWeek === DayOfTheWeek.TUESDAY ||
    dayOfWeek === DayOfTheWeek.WEDNESDAY ||
    dayOfWeek === DayOfTheWeek.THURSDAY ||
    dayOfWeek === DayOfTheWeek.FRIDAY ||
    dayOfWeek === DayOfTheWeek.SATURDAY ||
    dayOfWeek === DayOfTheWeek.SUNDAY
  );
}
